var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays and manages the characteristics of a damaged garage door including door type, width and motorization.
 * touches: declaration, externalDamage, garageDoorDamage
 * invariants: Selected information is synchronized with the GarageDoorDamage model through updateExternalDamage; displayed choices match the expected business characteristics for a garage door.
 * inputs: externalDamage, GARAGE_DOOR_TYPE_CHOICES, GARAGE_DOOR_WIDTH_CHOICES, GARAGE_DOOR_MOTORIZATION_CHOICES
 * outputs: updates external damage data through updateExternalDamage for doorType, isWidthGreaterThanStandard and isOpeningMotorized; displays validation errors associated with the related fields.
 * see: @declaration/components/externalDamage/ExternalDamageComponent, @declaration/constants/externalDamages, @shared/types/api/externalDamage
 */
import Component from 'vue-class-component';
import { UiRadio, UiCard } from '@claims-ia/design-system';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { GARAGE_DOOR_MOTORIZATION_CHOICES, GARAGE_DOOR_MOTORIZATION_LABEL, GARAGE_DOOR_TITLE, GARAGE_DOOR_TYPE_CHOICES, GARAGE_DOOR_TYPE_LABEL, GARAGE_DOOR_WIDTH_CHOICES, GARAGE_DOOR_WIDTH_LABEL, } from '@declaration/constants/externalDamages';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
let GarageDoor = class GarageDoor extends ExternalDamageComponent {
    get title() {
        return this.translateExternalDamageKey(GARAGE_DOOR_TITLE);
    }
    get subTitle() {
        return this.translateExternalDamageKey(GARAGE_DOOR_TYPE_LABEL);
    }
    get widthLabel() {
        return this.translateExternalDamageKey(GARAGE_DOOR_WIDTH_LABEL);
    }
    get motorizationLabel() {
        return this.translateExternalDamageKey(GARAGE_DOOR_MOTORIZATION_LABEL);
    }
    get doorTypeChoices() {
        return GARAGE_DOOR_TYPE_CHOICES.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
    get widthChoices() {
        return GARAGE_DOOR_WIDTH_CHOICES;
    }
    get motorizationChoices() {
        return GARAGE_DOOR_MOTORIZATION_CHOICES;
    }
    get doorType() {
        var _a;
        return (_a = this.externalDamage.doorType) !== null && _a !== void 0 ? _a : null;
    }
    set doorType(doorType) {
        this.updateExternalDamage({ doorType });
    }
    get isWidthGreaterThanStandard() {
        var _a;
        return (_a = this.externalDamage.isWidthGreaterThanStandard) !== null && _a !== void 0 ? _a : null;
    }
    set isWidthGreaterThanStandard(isWidthGreaterThanStandard) {
        this.updateExternalDamage({ isWidthGreaterThanStandard });
    }
    get isOpeningMotorized() {
        var _a;
        return (_a = this.externalDamage.isOpeningMotorized) !== null && _a !== void 0 ? _a : null;
    }
    set isOpeningMotorized(isOpeningMotorized) {
        this.updateExternalDamage({ isOpeningMotorized });
    }
};
GarageDoor = __decorate([
    Component({ components: { RadioPrimaryButton, UiRadio, UiCard } })
], GarageDoor);
export default GarageDoor;
